import React from "react";
import "../theme/AdministracionCatalogo.css";
import { OktaIDP, AuthenticationState } from "../components/OktaIDP";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { authProvider } from "../context/authProvider";
import { useNavigate } from "react-router-dom";
import { TableMisSolicitudes } from "../components/TableMisSolicitudes";

export const MisSolicitudes = () => {
  const navigate = useNavigate();

  return (
    <OktaIDP provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div>
              <div className="title-name-admin">
                <div className="icon-goback-title-admin">
                  <button className="button-goback-style" onClick={() => navigate(-1)}>
                    <ArrowBackIosIcon />
                  </button>
                  <div>Mis Solicitudes</div>
                </div>
              </div>
              <TableMisSolicitudes />
            </div>
          );
        }
      }}
    </OktaIDP>
  );
};
